export const getDomain = () => {
  const domain = `${window.location.protocol}//${window.location.host}`;
  return domain;
};

export const BOOKING_STAGES = {
  CREATED: { value: 'created', text: 'Created' },
  TIME_SLOTS_ADDED: {
    value: 'timeSlotsAdded',
    text: 'Preferences added by student',
  },
  SCHEDULED: { value: 'scheduled', text: 'Waiting for Coach Approval' },
  COACH_ASSIGNED: { value: 'coachAssigned', text: 'Accepted by coach' },
  SESSION_CONDUCTED: { value: 'sessionConducted', text: 'Session conducted' },
  FEEDBACK_SUBMITTED: {
    value: 'feedbackSubmitted',
    text: 'Pending Approval',
  },
  ADMIN_ON_HOLD: { value: 'adminOnHold', text: 'Kept on hold' },
  ADMIN_APPROVED: { value: 'adminApproved', text: 'Session approved' },
  CANCELLED: { value: 'cancelled', text: 'Cancelled' },
};

export const DEBOUNCE_DELAY_MS = 1000;
export const AG_GRID_PAGESIZE = 50;

export const MODULE_NAMES = {
  SALES_MARKETING: 'sales-marketting',
  FREE_USERS_INVITE_DEMO_CLASS: 'free-users-invite-demo-class',
  ALMAX_MODULE: 'almax-module',
};

export const MODULES_MAP = {
  [MODULE_NAMES.SALES_MARKETING]: [
    '/payment-links',
    '/coupons',
    '/refer-earn',
    '/almabetter-website',
    '/free-users',
  ],
  [MODULE_NAMES.FREE_USERS_INVITE_DEMO_CLASS]: ['/free-users'],
  [MODULE_NAMES.ALMAX_MODULE]: [
    '/almax-cohorts',
    '/almax-students',
    '/ab-cat-report',
    '/shortlisting',
    '/all-almax-students'
  ],
  'coach-operations': [
    '/coach',
    '/coach-v2',
    '/coach-verification',
    '/kyc-verifications',
    '/kyc-verifications-v2',
    '/expertise-verification',
  ],
  'learning-tech': [
    '/manage-bookings',
    '/manage-companies',
    '/projects',
    '/almax-submissions',
    '/session-visibility',
    '/new-group',
    '/session-builder',
    '/new-session',
    '/list-rating-templates',
    '/new-rating-template',
    '/question-builder',
    '/session-settings',
    '/cohort-dashboard',
    '/almax-dashboard',
    '/manage-abcat-extension',
    '/manage-classroom',
    '/progress-call',
    '/cohorts',
  ],
  'student-operations': ['/all-users', '/student-groups', '/all-almax-students', '/all-users/enroll-payment'],
  rbac: ['/rbac'],
  jobDashboard: ['/job-dashboardv2'],
  jobBoard: ['/job-board'],
  jobScraping: ['/job-scraping'],
  'super-admin': ['/'],
};

export const COURSE_TYPE = {
  DATA_SCIENCE: 'data-science',
  WEB3: 'web3',
  UG_DIPLOMA_CS: 'ug-diploma-cs',
  // DATA_ENGINEERING: 'data-engineering',
};

export const COURSE_TYPE_SHORT_NAMES_MAPPING = {
  [COURSE_TYPE.WEB3]: 'Web3',
  [COURSE_TYPE.DATA_SCIENCE]: 'Data Science',
  [COURSE_TYPE.UG_DIPLOMA_CS]: 'UG Diploma CS',
  // [COURSE_TYPE.DATA_ENGINEERING]: 'Data Engineering',
};

export const COURSE_TYPE_NAMES_MAPPING = {
  [COURSE_TYPE.DATA_SCIENCE]: 'Full Stack Data Science',
  [COURSE_TYPE.WEB3]: 'Full Stack Web Development with Web3',
  [COURSE_TYPE.UG_DIPLOMA_CS]: 'UG Diploma in Computer Science',
  // [COURSE_TYPE.DATA_ENGINEERING]: 'Full Stack Data Engineering',
};

export const PLAN_TYPES = {
  PRO_LIVE: 'pro_live',
  MASTERS: 'masters',
};

export const PLAN_TYPE_ACCORDING_TO_COURSE_TYPE = {
  [COURSE_TYPE.DATA_SCIENCE]: [PLAN_TYPES.PRO_LIVE, PLAN_TYPES.MASTERS],
  [COURSE_TYPE.WEB3]: [PLAN_TYPES.PRO_LIVE, PLAN_TYPES.MASTERS],
  [COURSE_TYPE.UG_DIPLOMA_CS]: [PLAN_TYPES.PRO_LIVE],
};
